export const articleObj1 = {
  pic_url:
    "https://images.pexels.com/photos/3571094/pexels-photo-3571094.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  article_url:
    "https://marcjarrett.medium.com/2-billion-reasons-to-use-whatsapp-for-networking-a49e1762b9fd",
  name: "2 Billion Reasons To Use WhatsApp For Networking",
  description: "4 min read",
};

export const articleObj2 = {
  pic_url: "https://miro.medium.com/max/1400/0*gfv8uG46CwpY12zY",
  article_url:
    "https://marcjarrett.medium.com/is-your-networking-working-4dfb2d88061c",
  name: "Is YOUR Networking Working?",
  description: "3 min read",
};

export const articleObj3 = {
  pic_url:
    "https://images.pexels.com/photos/860227/pexels-photo-860227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  article_url:
    "https://marcjarrett.medium.com/networking-isnt-for-everyone-are-you-one-of-them-bb3e5b329245",
  name: "Networking Isn’t For Everyone — Are You One Of Them?",
  description: "2 min read",
};

export const articleObj4 = {
  pic_url:
    "https://images.pexels.com/photos/4226140/pexels-photo-4226140.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  article_url:
    "https://marcjarrett.medium.com/why-virtual-networking-is-more-important-now-than-ever-18ad71f318af",
  name: "Why VIRTUAL Networking Is More Important Now Than Ever",
  description: "3 min read",
};

export const articleObj5 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4D12AQFliki9fiJ8tA/article-cover_image-shrink_423_752/0/1575526561281?e=1631145600&v=beta&t=iqt4e0grlCOrERvHBGjx8wbqc4NJJKKz2XHMVKyt7hs",
  article_url:
    "https://www.linkedin.com/pulse/how-virtual-networking-trumps-real-world-marc-jarrett/",
  name: "How Virtual Networking Trumps ‘In Person’ (F2F) Networking",
  description: "3 min read",
};
